import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "services/store/ReduxStore";

export const userSelector = (state: RootState) => state.userSlice.user;
export const userPermissionsSelector = (state: RootState) => state.userSlice.permissions;

export const userIdSelector = createSelector(
    userSelector,
    (user) => {
        if (!user) return null;
        return user.id;
    }
);

export const userIsLoggedInSelector = createSelector(
    userIdSelector,
    (userId) => {
        return !!userId;
    }
);

export const userLanguageSelector = createSelector(
    userSelector,
    (user) => {
        if (!user) return null;
        return user.language;
    }
);

  export const userHasFlagSelector = createSelector(
    [
      userSelector,
      (state, flag) => flag,
    ], (user, flag) => {
  
      if (!user) return false;
      if (!flag) return false;
      if (!user.flags) return false;
  
      const flags = user.flags && user.flags || [];
      return flags.includes(flag);
  
    }
  );

  export const userHasPhoneVerifySelector = createSelector(
    userSelector,
    (user) => !!user?.phone && !!user.phone_verified_at
  );

  export const userHasPhoneNumberSelector = createSelector(
    userSelector,
    (user) => !!user?.phone
  );
